import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Form from "./common/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { updatePlay } from "../store/play";
import { removeError, uploadFile } from "../store/fileUpload";
import { removeStartElem } from "../store/start";
import StartLoader from "./hoc/startLoader";
import { CheckService } from "../utils/checkSecret";
import { getCurrentGroup } from "../store/groups";
import { GoArrowRight } from "react-icons/go";
import configFile from "../config.js";
import { getLocation, LoadLocationByTaskId } from "../store/location.js";
import ErrorModal from "./common/modal/ErrorModal.jsx";
import { useErrorModal } from "../hook/useErrorModal.jsx";
import { useI18n } from "../i18n/LanguageContext";

function Task() {
  const dispatch = useDispatch();
  const { t } = useI18n();

  const { country } = useParams();

  const group = useSelector(getCurrentGroup());

  const [videoFiles, setVideoFiles] = useState(null);

  const { isOpen, openModal, closeModal, modalProps } = useErrorModal();

  const location = useLocation();
  const { number, task, play, start } = location.state;

  useEffect(() => {
    dispatch(LoadLocationByTaskId(task._id));
  }, [dispatch, task._id]);

  const { isLoading, error } = useSelector((state) => state.fileUpload);

  useEffect(() => {
    openModal(error);
  }, [error]);

  const taskLocation = useSelector(getLocation());

  const navigate = useNavigate();

  const saveWord = (letter, num) => {
    const newSecret = play.secret
      .split("")
      .map((elem, index) => (index === Number(num) ? (elem = letter) : elem))
      .join("");
    const check = CheckService.checkSecret(newSecret);

    dispatch(
      updatePlay({
        ...play,
        secret: newSecret,
        endPlay: !check ? false : true,
      })
    );
  };

  const handleSave = (lett, num) => {
    saveWord(lett, num);
    dispatch(removeStartElem(start._id));
    navigate(-2);
  };
  const timeNow = Date.now();
  useEffect(() => {
    if (
      group &&
      group.missionId &&
      play &&
      !play.timeLock &&
      start &&
      Number(start.time) + Number(configFile.REACT_APP_START_TIME) < timeNow
    ) {
      handleSave("0", number);
    }
  }, [start, group]);

  const handleLoadVideo = (e) => {
    setVideoFiles(e.target.files[0]);
  };

  useEffect(() => {
    if (
      group &&
      group.missionId &&
      play &&
      !play.timeLock &&
      Date.parse(play.created_at) + Number(configFile.REACT_APP_PLAY_TIME) <
        timeNow
    ) {
      dispatch(
        updatePlay({
          ...play,
          endPlay: true,
        })
      );
      if (start) {
        dispatch(removeStartElem(start._id));
      }
    }
  }, [play, group, start]);

  const handleUpload = useCallback(() => {
    if (error) {
      dispatch(removeError());
    }
    if (videoFiles) {
      dispatch(uploadFile(videoFiles, task._id));
      setVideoFiles(null);
    }
  }, [videoFiles, error, dispatch, task._id]);

  return (
    <>
      <StartLoader>
        <div className="w-full text-lg sm:text-lg">
          <div className="py-5">
            <div className="text-lg font-medium text-center py-5">
              {task.name}
            </div>
            <div className="border-solid border-4">
              <div className="mx-3 sm:mx-10 justify-between bg-lime-100 hover:bg-lime-50 py-5 px-10 ring-4 hover:ring-neutral-400 my-5 rounded-sm">
                <p>{task.description}</p>
                {taskLocation && (
                  <div className="py-4 flex md:flex-row flex-col">
                    <p className="p-2">
                      {t("location.lat")}:
                      <span className="px-5">{taskLocation?.latitude}</span>
                    </p>
                    <p className="p-2">
                      {t("location.lng")}:
                      <span className="px-5">{taskLocation?.longitude}</span>
                    </p>
                  </div>
                )}
              </div>

              <div className="bg-slate-100 py-10">
                <h2 className="flex justify-center font-bold">
                  {t("task.info")}
                </h2>
                <div className="mx-3 sm:mx-10 justify-between py-3">
                  {t("task.infoText")}
                </div>
              </div>
            </div>
          </div>
          {start && !start.check && (
            <div className="flex flex-col">
              <div className="flex justify-center py-10">
                <Form
                  taskId={task._id}
                  videoFiles={videoFiles}
                  handleUpload={handleUpload}
                  handleLoadVideo={handleLoadVideo}
                  isLoading={isLoading}
                  playId={play._id}
                  start={start}
                  error={error}
                />
              </div>
            </div>
          )}
          {error && (
            <ErrorModal
              {...modalProps}
              type="error"
              title={t("task.uploadError")}
              isOpen={isOpen}
              message={error}
              buttonText={t("common.close")}
              onChange={() => setVideoFiles(null)}
              onClose={() => {
                closeModal();
                dispatch(removeError());
              }}
            />
          )}

          {start && start.check ? (
            <div>
              <button
                type="button"
                onClick={() => handleSave("0", number)}
                className="w-40 h-10 m-5 rounded bg-green-400 mr-5 hover:bg-green-500"
              >
                {t("task.finish")}
              </button>
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row items-center">
              <div className="flex justify-center m-5 p-2">
                {t("task.atPointHint")}
                <div className="py-1 px-3">
                  <GoArrowRight />
                </div>
              </div>

              <Link
                to={`/${country}/job/${group?.missionId}`}
                className="hover:border-2 hover:border-black px-4 py-2 rounded-md bg-green-400 mr-5 hover:bg-green-500"
              >
                {t("task.atPoint")}
              </Link>
            </div>
          )}
        </div>
      </StartLoader>
    </>
  );
}

Task.propTypes = {};

export default Task;
